import { Box, Button, Stack } from "@mui/material";
import React, { useState } from "react";
import ChangePassword from "./changePassword";
import Notification from "./notification";
import { useTheme } from "@mui/material/styles";
import useResponsive from "../../hooks/useResponsive";
import AddWallet from "./addWallet";

const btn = {
  fontFamily: "Outfit",
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "23.79px",
  padding: "6px 12px",
  borderRadius: "12px",
  width: 160,
  height: "40px",
  "&: hover": {
    background: "#284cb1",
    color: "#fff",
    opacity: "35%",
  },
};

const ProfileControls = () => {
  const [active, setActive] = useState("password");
  const theme = useTheme();
  const handleMode = (value: string) => setActive(value);
  return (
    <Box sx={{ my: 4, width: "100%" }}>
      <Box sx={{ display: "flex", overflowX: "auto" }}>
        <Stack
          direction={"row"}
          sx={{
            background: theme.palette.lightBlue.main,
            padding: 2,
            borderRadius: "20px",
            gap: 1,
          }}
        >
          <Button
            onClick={() => handleMode("password")}
            sx={{
              ...btn,
              background: active === "password" ? "#284CB1" : "",
              color: active === "password" ? "#fff" : "#284CB1",
            }}
          >
            Change Password
          </Button>
          <Button
            onClick={() => handleMode("notification")}
            sx={{
              ...btn,
              background: active === "notification" ? "#284CB1" : "",
              color: active === "notification" ? "#fff" : "#284CB1",
            }}
          >
            Notification
          </Button>
          <Button
            onClick={() => handleMode("wallets")}
            sx={{
              ...btn,
              background: active === "wallets" ? "#284CB1" : "",
              color: active === "wallets" ? "#fff" : "#284CB1",
            }}
          >
            Wallets
          </Button>
        </Stack>
      </Box>
      <Box>
        {active === "password" && <ChangePassword />}
        {active === "notification" && <Notification />}
        {active === "wallets" && <AddWallet />}
      </Box>
    </Box>
  );
};

export default ProfileControls;
